import Component from '../Component';

class Item extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.render.setRefs(this.refs);
		this.props.render.componentDidMount();
	}

	render() {
		return `
            <li class="sidepanel__item">
                ${this.props.render.render()}
            </li>
        `;
	}
}

export default Item;